import { Working } from "../../../../../shared/ui/Working";
import { usePageTitle } from "../../../../../shared/hooks/usePageTitle";
import { PageHead, PageShell } from "../../components/PageShell";
import { useTranslation } from "../../i18n/useTranslation";

/**
 * THE PASSWORD-RESET PAGE IS ITS OWN CHUNK (entry headroom recovery, Web
 * Director, 2026-10-28): `/:slug/book/reset` is reached from Sign in's
 * "Forgot password?" only, so every booking visitor carried it. The route
 * loads it (router/routes.tsx), a first URL on it starts it with the entry
 * (router/index.tsx), and Sign in starts it when it offers the link.
 * Its own module so none of those imports the route table.
 */
export const loadBookRecovery = () => import("./BookRecovery");

/** The router's fallback while the chunk loads: the page's shell, heading and title, then the page itself. */
export function BookRecoveryLoading() {
  const { t } = useTranslation();
  usePageTitle(t("recovery.title"));
  return (
    // `route-loading` tells the fallback from the page (tests wait for the page).
    <PageShell testId="book-recovery" state="route-loading" legal={false}>
      <PageHead title={t("recovery.title")} />
      <Working>{t("profile.loading")}</Working>
    </PageShell>
  );
}
